import { Form } from 'factorial-form'

class Email extends Form {
  constructor(values: {}) {
    super(values, {
      email: 'string',
      unconfirmed_email: 'string',
      submitted_password: 'string',
    })
  }
}

export default Email
